import { readFileSync } from 'node:fs'
import { requireInitializedProject } from '@core-engine/commands/require-init.js'
import {
  createAddCommand,
  createAddFieldCommand,
  createCreateCommand,
  createGenerateCommand,
  createInitCommand,
  createListIntegrationsCommand,
  createListPluginsCommand,
  createRemoveCommand,
  createRemoveSchemaCommand,
  createSeedCommand,
  createUninstallCommand,
  createUpdateCommand,
  createUpdateDepsCommand,
  createUpdateStylesCommand
} from '@core-engine/commands/runtime.js'
import { nextCommandRuntime } from '@next-adapter/commands-runtime.js'
import { Command } from 'commander'

const { version } = JSON.parse(
  readFileSync(new URL('../package.json', import.meta.url), 'utf-8')
) as { version: string }

const program = new Command()

program
  .name('betterstart')
  .description('Scaffold a plugin and integration based Admin into any Next.js 16 application')
  .version(version)

program.hook('preAction', (_command, actionCommand) => {
  requireInitializedProject(actionCommand)
})

program.addCommand(createAddCommand(nextCommandRuntime))
program.addCommand(createAddFieldCommand(nextCommandRuntime))
program.addCommand(createCreateCommand(nextCommandRuntime))
program.addCommand(createInitCommand(nextCommandRuntime))
program.addCommand(createListIntegrationsCommand(nextCommandRuntime))
program.addCommand(createListPluginsCommand(nextCommandRuntime))
program.addCommand(createGenerateCommand(nextCommandRuntime))
program.addCommand(createRemoveCommand(nextCommandRuntime))
program.addCommand(createRemoveSchemaCommand(nextCommandRuntime))
program.addCommand(createSeedCommand(nextCommandRuntime))
program.addCommand(createUninstallCommand(nextCommandRuntime))
program.addCommand(createUpdateCommand(nextCommandRuntime))
program.addCommand(createUpdateDepsCommand(nextCommandRuntime))
program.addCommand(createUpdateStylesCommand(nextCommandRuntime))

program.parse()
